import { AgGridService } from "@topline/services/agGridService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { GridOptions } from "ag-grid-community";
import ng from "angular";
import { Gen } from "@topline/services/api";
import { ImsIoMarketDataProvider } from "../services/imsIoMarketDataProvider";
import { isTrue } from "@topline/services/boolean";

class FileMarketAvailableProductsComponentController {
    public gridApi: $TSFixMe;
    public serverOperation: ng.IPromise<Gen.FileMarketAvailableProductDTOPageableListResult>;
    public actionColumnTemplate: string;
    public refresh: $TSFixMe;
    public excludedProductCodes: string[];
    public showAddAllButton: string;
    public callbackScope: $TSFixMe;
    public onAddAll: $TSFixMe;
    public watchTimeout: $TSFixMe;
    public filters: Gen.MarketFilterDTO[];
    public countryCode: string;

    static $inject = [
        "$scope",
        "$timeout",
        ImsIoMarketDataProvider.componentName,
        angularServicesNames.$translate,
        AgGridService.componentName
    ];

    constructor(
        private $scope: ng.IScope,
        private $timeout: ng.ITimeoutService,
        private imsIoMarketDataProvider: ImsIoMarketDataProvider,
        private $translate: ng.translate.ITranslateService,
        private agGridService: AgGridService
    ) { }

    $onInit() {
        this.$scope.$on("LanguageChanged", () => this.agGridService.refreshGridLanguage(this.gridApi));
        this.$scope.$watch(() => this.countryCode, () => this.refreshGrid());

        this.$scope.$watchCollection(
            () => this.excludedProductCodes,
            () => {
                this.reloadProductsDebounce();
            }
        );

        this.$scope.$watchCollection(
            () => this.filters,
            () => this.reloadProductsDebounce()
        );

        this.refresh = () => {
            this.refreshGrid();
        };

        this.reloadProductsDebounce();
    }

    public gridOptions: GridOptions = {
        columnDefs: [
            {
                field: "productCode",
                headerValueGetter: () => this.$translate.instant("MARKET.FILE_MARKET_AVAILABLE_PRODUCTS.ORACLE_INDEX"),
                tooltipField: "productCode"
            },
            {
                field: "sku",
                tooltipField: "sku",
                headerValueGetter: () => this.$translate.instant("MARKET.FILE_MARKET_AVAILABLE_PRODUCTS.SKU")
            },
            {
                field: "brand",
                tooltipField: "brand",
                headerValueGetter: () => this.$translate.instant("MARKET.FILE_MARKET_AVAILABLE_PRODUCTS.PRODUCT")
            },
            {
                field: "market",
                tooltipField: "market",
                headerValueGetter: () => this.$translate.instant("MARKET.FILE_MARKET_AVAILABLE_PRODUCTS.MARKET")
            },
            {
                field: "region",
                tooltipField: "region",
                headerValueGetter: () => this.$translate.instant("MARKET.FILE_MARKET_AVAILABLE_PRODUCTS.REGION")
            },
            {
                field: "businessUnit",
                tooltipField: "businessUnit",
                headerValueGetter: () => this.$translate.instant("MARKET.FILE_MARKET_AVAILABLE_PRODUCTS.BU")
            },
            {
                field: "line",
                tooltipField: "line",
                headerValueGetter: () => this.$translate.instant("MARKET.FILE_MARKET_AVAILABLE_PRODUCTS.LINE")
            },
            {
                field: "ownerName",
                tooltipField: "ownerName",
                headerValueGetter: () => this.$translate.instant("MARKET.FILE_MARKET_AVAILABLE_PRODUCTS.PLANNER"),
                sortable: false
            },
            {
                headerValueGetter: () => this.$translate.instant("MARKET.FILE_MARKET_AVAILABLE_PRODUCTS.ACTIVE"),
                field: "isActive",
                filter: "agSetColumnFilter",
                cellRenderer: (params: $TSFixMe) =>
                    params.value != null ? this.$translate.instant(isTrue(params.value) ? "YES" : "NO") : "",
                filterParams: {
                    cellRenderer: (params: $TSFixMe) =>
                        params.value != null ? this.$translate.instant(isTrue(params.value) ? "YES" : "NO") : ""
                },
                sortable: false
            },
            {
                field: "actions",
                headerValueGetter: () => this.$translate.instant("ACTIONS"),
                cellRenderer: () => this.actionColumnTemplate,
                sortable: false
            }
        ],
        angularCompileRows: true,
        defaultColDef: {
            sortable: true,
            resizable: true,
            filter: false
        },
        animateRows: true,
        pagination: true,
        paginationPageSize: 10,
        rowGroupPanelShow: "never",
        domLayout: "autoHeight",
        suppressMultiSort: true,
        localeTextFunc: this.agGridService.transalteFunc,
        onGridReady: config => {
            this.gridApi = config.api;
            config.api.sizeColumnsToFit();
            this.refreshGrid();
        },
        onGridSizeChanged: config => config.api.sizeColumnsToFit()
    };

    public refreshGrid() {
        if (!this.gridApi) {
            return;
        }

        if (this.countryCode && this.filters && this.filters.length > 0) {
            this.serverOperation = this.imsIoMarketDataProvider
                .getFileMarketAvailableProducts(this.filters, this.countryCode, this.excludedProductCodes)
                .then(result => this.gridApi.setRowData(result.items));
        } else {
            this.gridApi.setRowData([]);
        }
    }

    public reloadProductsDebounce() {
        if (angular.isDefined(this.watchTimeout)) {
            this.$timeout.cancel(this.watchTimeout);
        }
        this.watchTimeout = this.$timeout(() => {
            this.refreshGrid();
        }, 500);
    }

    public addAll() {
        if (this.countryCode && this.filters && this.filters.length > 0) {
            this.imsIoMarketDataProvider
                .getFileMarketAvailableProducts(this.filters, this.countryCode, this.excludedProductCodes)
                .then(data =>
                    this.onAddAll({
                        products: data.items
                    })
                );
        }
    }
}

export class FileMarketAvailableProductsComponent implements ng.IComponentOptions {
    static componentName = "fileMarketAvailableProducts";
    bindings = {
        callbackScope: "=",
        actionColumnTemplate: "<",
        refresh: "=",
        excludedProductCodes: "<",
        showAddAllButton: "@",
        onAddAll: "&",
        filters: "<",
        countryCode: "<"
    };
    controller = FileMarketAvailableProductsComponentController;
    template = require("./fileMarketAvailableProductsComponent.html");
}

angular
    .module("topline.components")
    .component(FileMarketAvailableProductsComponent.componentName, new FileMarketAvailableProductsComponent());
